import {Tooltip} from 'platform/components';
import {Heading, HStack, Text} from 'platform/foundation';

import {Fragment, ReactNode} from 'react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {DOT_CHARACTER, EMPTY_PLACEHOLDER} from 'shared/web';

export interface VehicleSpecificationSnippetTitleItem {
  title: string | number | null;
  tooltip: ReactNode;
}

interface VehicleSpecificationSnippetTitleProps {
  items: VehicleSpecificationSnippetTitleItem[];
}

export function VehicleSpecificationSnippetTitle(props: VehicleSpecificationSnippetTitleProps) {
  const items = props.items.filter(
    (
      item
    ): item is VehicleSpecificationSnippetTitleItem & {
      title: NonNullable<VehicleSpecificationSnippetTitleItem['title']>;
    } => isNotNilOrEmpty(item.title)
  );

  if (!items.length) {
    return (
      <Heading size={5} headingLevel={6}>
        {EMPTY_PLACEHOLDER}
      </Heading>
    );
  }

  return (
    <HStack spacing={1} align="center" wrap>
      {items.map((item, index) => {
        const title = item.title.toString();

        return (
          <Fragment key={title}>
            {index > 0 ? (
              <Text color="tertiary" size="small">
                {DOT_CHARACTER}
              </Text>
            ) : null}
            <Tooltip label={item.tooltip} placement="top">
              <Heading size={5} headingLevel={6}>
                {title}
              </Heading>
            </Tooltip>
          </Fragment>
        );
      })}
    </HStack>
  );
}
